import { Component, OnInit } from '@angular/core';
import { StaffService } from 'src/app/services/Staff/staff.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';

@Component({
  selector: 'app-staff-upload',
  templateUrl: './staff-upload.component.html',
  styleUrls: ['./staff-upload.component.css']
})
export class StaffUploadComponent implements OnInit {


  SelectUpload:any;
  Submitted:boolean=false;
  StaffList:any;
  EmployeeCategoryList:any;

  constructor(private staffservice: StaffService, public globalHelper: GlobalHelper,private spinnerService: Ng4LoadingSpinnerService,
    private lookupService:LookupService) { }
  
  StaffModel = {
    EmployeeCategoryID:0
}

onUpload(file) {
    this.SelectUpload = file[0];
}


ValidityState() {
    return this.StaffModel.EmployeeCategoryID == 0;
}


UploadStaff() {
    this.Submitted = true;
    if (!this.ValidityState() && this.SelectUpload!=null) {
      this.spinnerService.show();
        this.staffservice.UploadStaff(JSON.stringify(this.StaffModel),this.SelectUpload).subscribe((response: any) => {
            this.Submitted = false;
            this.StaffList = response.StaffList;
            this.globalHelper.CheckActionStatus(response);
            this.spinnerService.hide();
        });
    }

}

UpdateStaff() {
  this.spinnerService.show();
    this.staffservice.UpdateStaff(JSON.stringify(this.StaffList)).subscribe((response: any) => {
      this.globalHelper.CheckActionStatus(response);
      this.spinnerService.hide();
    });

}


  ngOnInit() {
    this.GetAllEmployeeCategory();
  }

  GetAllEmployeeCategory() {
    this.lookupService.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });

  }

}
